/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the prefix of a given `key` is invalid
 * @export
 * @class EnvInvalidKeyPrefixError
 * @extends {Error}
 */
export class EnvInvalidKeyPrefixError extends Error {
  /**
   * Creates an instance of EnvInvalidKeyPrefixError
   * @param {string} message The Error `message`
   * @memberof EnvInvalidKeyPrefixError
   */
  constructor(message) {
    super(message);
    this.name = `EnvInvalidKeyPrefixError`;
  }
}

/**
 * Called when the prefix of a given `key` is invalid
 * @param {string} key The invalid `key`
 * @returns {never} never
 */
const throwEnvInvalidKeyPrefixError = (key) => {
  throw new EnvInvalidKeyPrefixError(
    stripIndent(`
    Expected environment variable to start with "REACT_APP_".
    Got: "${key}"
    Use "REACT_APP_${key}" instead.
    See https://medium.com/@tacomanator/environments-with-create-react-app-7b645312c09d for an overview.
    `),
  );
};

export default throwEnvInvalidKeyPrefixError;
